import type {FullName, Name} from '../typedef';

type PrepareName = (name: Name | string) => FullName | null;

const emptyName = 'No Name';
const filterIllegalSymbols = (name: string) => name.replace(/[\uFFFC~`!@#$%^&*()\-_=+{}[\]|;:'",<.>?/\\\d]/g, '');

export const prepareName: PrepareName = name => {
    let firstName;
    let lastName;

    if (typeof name === 'string') {
        if (name !== emptyName) {
            const names = filterIllegalSymbols(name).split(' ');

            if (names.length > 1) {
                firstName = names[0];
                lastName = names[names.length - 1];
            }
        }
    } else {
        firstName = filterIllegalSymbols(name.firstName || '').trim();
        lastName = filterIllegalSymbols(name.lastName || '').trim();
    }

    if (firstName && lastName) {
        return {firstName, lastName};
    }

    return null;
};
